import { useState, useRef } from 'react';
import { useMapglContext } from './MapglContext';
import './GeolocationControl.css';

export function GeolocationControl() {
    const { mapglInstance, mapgl } = useMapglContext();
    const [status, setStatus] = useState('');
    const circleRef = useRef<any>(null);

    const handleGeolocation = () => {
        if (!mapglInstance || !mapgl) {
            setStatus('Карта не загружена');
            return;
        }

        if (!navigator.geolocation) {
            setStatus('Геолокация не поддерживается вашим браузером');
            return;
        }

        setStatus('Определение местоположения…');

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const center = [position.coords.longitude, position.coords.latitude];

                setStatus('');

                // Удаляем предыдущий маркер, если есть
                if (circleRef.current) {
                    circleRef.current.destroy();
                }

                // Создаём круглый маркер с двойной обводкой
                circleRef.current = new mapgl.CircleMarker(mapglInstance, {
                    coordinates: center,
                    radius: 14,
                    color: '#0088ff',
                    strokeWidth: 4,
                    strokeColor: '#ffffff',
                    stroke2Width: 6,
                    stroke2Color: '#0088ff55',
                });

                // Устанавливаем центр карты и зум
                mapglInstance.setCenter(center);
                mapglInstance.setZoom(16);
            },
            () => {
                setStatus('Не удалось определить ваше местоположение');
            }
        );
    };

    return (
        <div className="geolocation-control">
            <button className="geolocation-button" onClick={handleGeolocation}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                >
                    <path
                        fill="currentColor"
                        d="M17.89 26.27l-2.7-9.46-9.46-2.7 18.92-6.76zm-5.62-12.38l4.54 1.3 1.3 4.54 3.24-9.08z"
                    />
                </svg>
            </button>
            {status && <p className="geolocation-status">{status}</p>}
        </div>
    );
}
